import { render, staticRenderFns } from "./modal-select-language.vue?vue&type=template&id=069686ca&scoped=true"
import script from "./modal-select-language.vue?vue&type=script&lang=js"
export * from "./modal-select-language.vue?vue&type=script&lang=js"
import style0 from "./modal-select-language.vue?vue&type=style&index=0&id=069686ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069686ca",
  null
  
)

export default component.exports